// The per-environment absolute base URL (ADR-0053 §1). Injected at BUILD time as
// `VITE_SITE_URL` so the prerendered `<head>` bakes the right host per env:
// staging → `https://staging.pufimi.pl`, prod → `https://pufimi.pl` (set in the
// deploy workflows). Every absolute head URL (`canonical`, `og:url`, `og:image`,
// JSON-LD) flows from here through the pure `canonicalUrl`/`buildHead` — never
// from `window.location`, which is wrong under prerender and unseen by non-JS
// social scrapers.
//
// This is the ONE impure seam (it reads `import.meta.env`); the SEO model modules
// stay pure and take the resolved base as an argument. The default is the prod
// apex, so a local `pnpm build` with no env still produces valid absolute URLs;
// staging MUST set `VITE_SITE_URL` to its own host so it never emits a canonical
// pointing at prod (ADR-0053 §3 — apex canonical, staging stays behind Access).

/** Prod apex fallback when `VITE_SITE_URL` is unset (ADR-0053 §3). */
export const DEFAULT_SITE_URL = "https://pufimi.pl";

/** The build-time absolute base for this environment. Read at call time so a
 *  build injects it and tests can stub `import.meta.env`. */
export function siteUrl(): string {
  const configured = (import.meta.env.VITE_SITE_URL ?? "").trim();
  return configured || DEFAULT_SITE_URL;
}
